import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/adversal': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M482.1 32c24.5 0 29.9 5.6 29.9 30.2v388.1c0 24.5-5.5 29.7-29.9 29.7h-453.4c-22.9 0-28.7-5.6-28.7-28.9v-390.2c0-23 5.8-28.9 28.7-28.9h453.4zM178.4 220.3c9.4 7.2 12.4 17.1 11.3 27.3-1.8 19.1-75.8 11.4-114 30.9-27.2 13.9-42.7 41.7-39.6 71 6.7 64.7 89.6 79.7 147 43.3 4.6-3.2 8.3-4.9 11.9-1 2.1 2.6 2 4 3.9 6.2 7.3 9.6 38.2 14.1 46.6 7.4 3.1-2.8 4.6-6.3 2.7-10.7-13.6-30.5-6.6-63-9.3-88.8 0-69.3 6.4-111.7-34.5-128.5-41.9-17.4-84.2-16.6-125.3 4.8-16.3 9-53.7 52.9-24.9 64.3 5.3 2.3 12.8 4 22.5 5.5 8.2 1.2 13.2 2.8 17.5-8.3 12.1-32.1 56.7-43.6 84.2-23.4zM465.1 442.3c0-14.3-9.8-9.9-16.6-9.9-132.3-0.4-264.5-0.4-396.8 0-6.6 0-16.7-4.8-17.1 9.1-0.4 15.5 10.4 10.7 17.8 10.7h394.9c6.7 0 17.8 5.2 17.8-9.9zM468.9 101.8c0-0.2 0-0.3 0.1-0.5 0-9.9-3.5-15.1-13.6-14.3-3.1 0.4-6.6 0-9.7 0-26.1 0-26 0-26 26.2v71c-79.2-45.6-124.3 6.6-136.1 30.5-16.4 32.9-21.8 66.6-15.7 100 16.3 92.3 91 114.9 144.4 85.2 4.6-2.8 6.6-7.5 12.4 1.2 8.6 12.7 23.7 5.2 36.1 5.6 7.4 0 8.1-8.2 8.1-13.9v-291zM417.4 334.1c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2 0.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zM122.6 369.4c-7.5-1.3-33-3.3-33.7-27.8-0.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/adversal.js
// module id = 539
// module chunks = 0